<template>
<!-- min-height (sabit height degil): uzun mesajlarda kutu icerige gore buyur,
     kaydirma cubugu cikmaz. Kisa mesajlarda gorunum eskisi gibi kalir. -->
<customdialog v-model="dialog" :maxWidth="options.width" :title="title" :cardtextstyle="'min-height: 160px;'">

  <!-- pre-line: mesajdaki satir sonlari korunur (cok satirli aciklamalar icin).
       Tek satirli mevcut kullanimlarda gorunum degismez. -->
  <v-card-text v-show="!!message" style="white-space: pre-line">{{ message }}</v-card-text>
  <v-checkbox v-show="!!options.message" v-model="onay" color="green">
    <div slot="label">
      {{options.message}}
    </div>
  </v-checkbox>

  <template slot="btn">
    <v-btn color="primary" flat @click.native="yes()">{{btnYesCaption}}</v-btn>
  </template>

</customdialog>
</template>

<script>
import customdialog from "@/components/app/coper/comp/customdialog.vue";

export default {
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      onay: false,
      btnYesCaption: this.$t('Yes'),
      messageShowDialog: false,

      options: {
        color: "primary",
        width: 380,
        message: null
      }
    };
  },
  components: {
    customdialog
  },
  methods: {
    open(title, message, options) {
      this.btnYesCaption = this.$t('Yes')
      this.messageShowDialog = false
      this.onay = false;
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    messageShow(title, message, options) {
      this.btnYesCaption = this.$t('Close')
      this.messageShowDialog = true
      this.onay = false;
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    yes() {
      if (this.options.message) {
        if (this.onay) {
          this.cozumle(true);
        }
      } else {
        this.cozumle(true);
      }
    },
    cancel() {
      this.cozumle(false);
    },

    // open()/messageShow() tarafindan dondurulen Promise'i TEK noktadan cozer.
    // resolve null'lanir ki asagidaki watch tekrar cozmeye calismasin.
    cozumle(sonuc) {
      if (this.resolve) {
        this.resolve(sonuc);
        this.resolve = null;
        this.reject = null;
      }
      this.dialog = false;
    }
  },

  watch: {
    // Dialog "Evet" disinda bir yolla kapandiginda (baslikataki X, ESC veya
    // arka plana tiklama) Promise HIC cozulmuyordu; cagiran taraf sonsuza dek
    // askida kaliyordu. Bu, cift tiklama korumali kaydetbutonu ile birlesince
    // butonun kalici olarak pasif kalmasina yol aciyordu.
    dialog(yeni) {
      if (yeni === false && this.resolve) {
        this.resolve(false);
        this.resolve = null;
        this.reject = null;
      }
    }
  }
};
</script>
